export default __webpack_public_path__ + "static/media/open-nav.7a327896.svg";